module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"account_set_menu":"Account Settings","account_set_1":"Hardware List","node_list":"Node List","lite_node":"Lite Node"},"zn":{"account_set_menu":"硬件列表","account_set_1":"硬件列表","node_list":"节点列表","lite_node":"轻节点"}}')
  delete Component.options._Ctor
}
